import type { PermissionSet } from "@/auth/permissions";
import {
  SHIPPED_MODULES,
  sectionPermissions,
  type ModuleDefinition,
  type SectionDefinition,
} from "@/config/modules";

export function visibleSections(
  module: ModuleDefinition,
  permissions: PermissionSet,
): SectionDefinition[] {
  return module.sections.filter(
    (section) =>
      !section.unfinished &&
      !section.inModuleOnly &&
      sectionPermissions(section).every((permission) =>
        permissions.has(permission),
      ),
  );
}

/**
 * The modules worth rendering.
 *
 * A module is visible when any of its sections is. There is no module-level
 * permission to keep in sync, which is why the catalogue keys are shaped
 * `module.section.action` and stop there.
 *
 * §11.2: "the sidebar renders only modules the user holds a permission for, so
 * a warehouse operator sees four."
 */
export function visibleModules(permissions: PermissionSet): ModuleDefinition[] {
  return SHIPPED_MODULES.filter(
    (module) => visibleSections(module, permissions).length > 0,
  );
}
